import { FieldType, TvRadioField } from '../../../../components/GenericSection';
import { RowType } from '../../../../components/GenericSection/types';
export var TV_RADIO_PUBINFO_SECTION_FIELDS = [{
  field: TvRadioField.TITLE,
  labelText: 'Source title',
  recommended: false,
  type: FieldType.TEXT
}, {
  field: TvRadioField.CALL,
  labelText: 'Call',
  recommended: false,
  type: FieldType.TEXT
}, {
  field: TvRadioField.NETWORK,
  labelText: 'Network',
  recommended: false,
  type: FieldType.TEXT
}, {
  rowtype: RowType.SM_TWO_ROW,
  fields: [{
    field: TvRadioField.CITY,
    labelText: 'City',
    recommended: false,
    type: FieldType.TEXT
  }, {
    field: TvRadioField.STATE,
    labelText: 'State',
    recommended: false,
    type: FieldType.TEXT
  }]
}, {
  type: FieldType.PUBDATE,
  labelText: 'Date aired',
  field: TvRadioField.DATE,
  formikFieldNames: ['day', 'month', 'year']
}, {
  type: FieldType.RADIO,
  labelText: 'Medium',
  options: [{
    key: 'yes',
    value: 'TV'
  }, {
    key: 'no',
    value: 'Radio'
  }],
  defaultSelectedIndex: 1,
  field: TvRadioField.MEDIUM,
  alignment: 'horizontal'
}];